export default __webpack_public_path__ + "static/media/influencer.83ed24a4.svg";